<template>
  <BaseCell align="right">
    <div class="allocation-cell">
      <component :is="component">
        <BaseText size="p5" :color="color">{{ text.value }}</BaseText>
      </component>
      <component :is="component" v-if="text.subValue">
        <BaseText size="p6">{{ text.subValue }}</BaseText>
      </component>
    </div>
  </BaseCell>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

import { BaseCell, BaseText } from '@warrenbrasil/nebraska-web';
import { Money } from '@/modules/common/components/Money';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

enum colorType {
  default = 'default',
  positive = 'positive',
  negative = 'negative'
}

interface DataProps {
  value: string;
  color: string;
  isHideable: boolean;
  subValue?: string;
}

interface Props {
  text: DataProps;
}
const props = defineProps<Props>();

const component = computed(() => {
  return props.text.isHideable ? Money : 'div';
});

const color = computed(() => {
  switch (props.text.color) {
    case colorType.positive:
      return NebraskaColors.statusPositive;

    case colorType.negative:
      return NebraskaColors.statusNegative;

    case colorType.default:
    default:
      return NebraskaColors.elementPrimary;
  }
});
</script>

<style lang="less" scoped>
.allocation-cell {
  display: flex;
  flex-direction: column;
}
</style>
